import { type RouteLocationNormalized } from 'vue-router';

export const isPrivateRoute = (from: RouteLocationNormalized): boolean =>
  Boolean(from?.meta?.authorizedGroups?.length);
